var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "选择商品",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "120px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "商品来源：",
                    prop: "sourceType",
                    rules: [
                      {
                        required: true,
                        message: "请选择",
                        trigger: ["change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      on: { change: _vm.changeSourceType },
                      model: {
                        value: _vm.pram.sourceType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "sourceType", $$v)
                        },
                        expression: "pram.sourceType",
                      },
                    },
                    _vm._l(_vm.GOODS_TYPE_MAP, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.key, attrs: { label: item.key } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "绑定方式：",
                    prop: "type",
                    rules: [
                      {
                        required: true,
                        message: "请选择",
                        trigger: ["change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "type", $$v)
                        },
                        expression: "pram.type",
                      },
                    },
                    [
                      [1, 2, 3].includes(_vm.pram.sourceType)
                        ? _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("指定分类"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("指定标签"),
                      ]),
                      _vm._v(" "),
                      _vm.pram.sourceType != 3
                        ? _c("el-radio", { attrs: { label: 3 } }, [
                            _vm._v("指定SKU"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.pram.type
                ? _c(
                    "el-form-item",
                    { attrs: { label: "绑定内容：" } },
                    [
                      _vm.pram.type == 1 &&
                      [1, 2, 3].includes(_vm.pram.sourceType)
                        ? _c("el-cascader", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.cateIdsOption,
                              props: {
                                children: "child",
                                label: "name",
                                value: "id",
                                multiple: true,
                                leaf: 3,
                              },
                              clearable: "",
                            },
                            model: {
                              value: _vm.pram.cateIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "cateIds", $$v)
                              },
                              expression: "pram.cateIds",
                            },
                          })
                        : _vm.pram.type == 2
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.pram.tagIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pram, "tagIds", $$v)
                                },
                                expression: "pram.tagIds",
                              },
                            },
                            _vm._l(_vm.tagOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.labelName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          )
                        : _vm.pram.type == 3
                        ? _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  type: "textarea",
                                  rows: 4,
                                  resize: "none",
                                  placeholder: "请输入skuId",
                                },
                                model: {
                                  value: _vm.pram.skuId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.pram, "skuId", $$v)
                                  },
                                  expression: "pram.skuId",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveEdit } },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }